export default "__VITE_PUBLIC_ASSET__e4ebb7c8__"